import React, {
  createContext,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react'
import io from 'socket.io-client'

import { useAuth } from './auth'

const SocketContext = createContext({})

export const SocketProvider = (props) => {
  const { logged } = useAuth()

  const [socket, setSocket] = useState()

  useEffect(() => {
    function startSocket() {
      if (socket) {
        socket.open()
      } else {
        setSocket(
          io(process.env.REACT_APP_SOCKET_URL, { withCredentials: true })
        )
      }
    }

    if (logged) {
      startSocket()
    } else {
      if (socket) {
        socket.close()
      }
    }
  }, [logged, socket])

  const useSocketValues = useMemo(
    () => ({
      socket,
    }),
    [socket]
  )

  return (
    <SocketContext.Provider value={useSocketValues}>
      {props.children}
    </SocketContext.Provider>
  )
}

export function useSocket() {
  const context = useContext(SocketContext)
  return context
}
